import {Component, Object3D, RetainEmitter} from '@wonderlandengine/api';

export class EnemyPrefabs extends Component {
    static TypeName = 'enemy-prefabs';

    enemyPrefabs!: Object3D;
    onPrefabsLoaded = new RetainEmitter<[Object3D]>();

    async start() {
        const s = await this.engine.loadPrefab('Enemies.bin');
        const r = this.engine.scene.instantiate(s);

        this.enemyPrefabs = r.root;
        this.enemyPrefabs.parent = this.object;
        setTimeout(() => this.onPrefabsLoaded.notify(this.enemyPrefabs), 0);
    }
}
